import {SNP} from '../types/dashboard-genetics-general.types';

export const geneticsGenerateTooltipMessage = (snp: SNP): string => {
  return `<div class="genotype-tooltip">
    <div>
      <span class="genotype-tooltip__title">SNP:</span>
      ${snp.name}
    </div>
    <div>
      <span class="genotype-tooltip__title">Genes:</span>
      ${snp.mapped_gene}
    </div>

    <style>
      .genotype-tooltip {
        max-width: 300px;
        font-family: 'Montserrat', sans-serif;
        font-size: 14px;
        line-height: 17px;
        color: #2B3357;
      }

      .genotype-tooltip__title {
        font-weight: 600;
      }

      .genotype-tooltip__info {
        margin-top: 15px !important;
        white-space: pre-wrap;
      }

      .genotype-tooltip__person {
        margin-top: 15px !important;
        margin-bottom: 15px !important;
        display: flex;
        flex-wrap: wrap;
      }

      .genotype-tooltip > * {
          margin-right: 5px;
      }

      .genotype-tooltip__rating {
        display: inline-block;
      }

      .genotype-tooltip-wrap {
        display: flex;
      }

      .genotype-tooltip-wrap__split {
        height: 250px;
        width: 2px;
        background-color: black;
        margin: 5px 10px !important;
      }
    </style>

    <div>
      <span class="genotype-tooltip__title">Your genotype is:</span>
      ${snp.genotype}
    </div>

    <div class="genotype-tooltip__info">The ${snp.effect_allele} allele contributes to a ${snp.effect_text}</div>
    <div class="genotype-tooltip__info">You carry ${Math.abs(snp.patient_score)} effect allele(s) in this position</div>

    <div class="genotype-tooltip__person">
      <span class="genotype-tooltip__title">Referenced studies:</span>
      ${snp.studies
        .map((study, index) => {
          return `<a href="https://${study.link}" target="_blank">${study.citation}${index !== snp.studies?.length - 1 ? ', ' : ''}</a>`;
        })
        .join(' ')}
    </div>

    <div>
      <span class="genotype-tooltip__title">Scientific rigor:</span>
      <div class="genotype-tooltip__rating">
        <img src="/assets/images/genetics/star${snp.scientific_score > 0 ? '_rate' : ''}.svg" alt="">
        <img src="/assets/images/genetics/star${snp.scientific_score > 1 ? '_rate' : ''}.svg" alt="">
        <img src="/assets/images/genetics/star${snp.scientific_score > 2 ? '_rate' : ''}.svg" alt="">
        <img src="/assets/images/genetics/star${snp.scientific_score > 3 ? '_rate' : ''}.svg" alt="">
        <img src="/assets/images/genetics/star${snp.scientific_score > 4 ? '_rate' : ''}.svg" alt="">
      </div>
    </div>
  </div>`;
};

export enum UploadSteps {
  INFO = 'info',
  FILE = 'file',
  CONSENT = 'consent',
  COMPLETE = 'complete',
}
